import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function AlfaModal(props) {
  const {open, onClose, loading, onApply, enableAlfaIdAuth} = props

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          maxWidth: 344,
          width: '100%',
        },
      }}
    >
      <DialogTitle>
        <Stack direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography align='left' variant="h5">
            {enableAlfaIdAuth ? 'Отключить Альфа ID' : 'Включение Альфа ID'}
          </Typography>
          <IconButton size="large" onClick={onClose}>
            <Iconify icon="solar:close-circle-bold" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        {enableAlfaIdAuth ? 'Вы уверены что хотите отключить возможность авторизации через Альфа ID?' : 'Вы уверены что хотите включить возможность авторизации через Альфа ID?'}
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          onClick={onClose}
          variant="outlined"
          fullWidth
        >
          Отмена
        </Button>
        <LoadingButton
          size="large"
          variant="contained"
          color="inherit"
          loading={loading}
          fullWidth
          onClick={onApply}
        >
          {enableAlfaIdAuth ? 'Отключить' : 'Включить'}
        </LoadingButton>
      </DialogActions>
    </Dialog>

  );
}
